module.exports = __webpack_public_path__ + "media/images/logos/apple-5905acaa3a1123c8dafdf806df086004.svg";